<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false><p slot="title">商户中心</p></sub-ibox-title>
		<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleClickTabBar"></z-tab-bar>
		<section class="">
			<info v-show ="tabBarParams.active =='userCenter'"></info>
			<modify-pwd v-show ="tabBarParams.active =='modifPwd'"></modify-pwd>
			<!--<memberPubilc v-show ="tabBarParams.active =='memberPubilc'"></memberPubilc>-->
		</section>
	</div>
</template>
<script>
	import Info from "./Info.vue";
	import ModifyPwd from "./ModifyPwd.vue";
	export default {
		name: 'UserCenter',
		components: {
			Info,
			ModifyPwd
		},
		data() {
			return {
				tabBarParams:{
					list:[{
						title:'商户信息',
						type:'userCenter'
					},{
						title:'修改密码',
						type:'modifPwd'
					}],
					active:'userCenter'//默认
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleClickTabBar(type){
				this.tabBarParams.active = type
			}
		},
	    beforeRouteUpdate(to, from, next){
	    	this.tabBarParams.active = to.query.type || 'userCenter'
	    	next()
	    },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.tabBarParams.active = to.query.type || 'userCenter'
			})
		}

	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
</style>


// WEBPACK FOOTER //
// Index.vue?ee9f71a4